import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState, IStateDepartment } from 'src/entity/StateEntity';
import PromotionListPage from 'src/components/views/Promotion/PromotionListPage';

const mapStateToProps = ({
  userState: {isDomestic, isAgent, userInfo},
}: IStoreState) => ({
  isDomestic,
  isAgent,
  userInfo,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateDepartment>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionListPage);


// WEBPACK FOOTER //
// ./src/containers/PromotionList.ts